export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "Rapido",
  text1: "Benvenuto!",
  text2: "Elenco dei check-in: gestisci o invia un link per la registrazione dei tuoi ospiti.",
  text3: "Elenco dei check-in",
  text4: "Esporta",
  text5: "Nuovo check-in",
  text6: "Tutti",
  text7: "In sospeso",
  text8: "Completati",
  text9: "Oggi",
  text10: "Telefono",
  text11: "Nome",
  text12: "Numero documento",
  text13: "Paese",
  text14: "Check-in",
  text15: "Chiavi",
  text16: "Consegnate",
  text17: "In attesa",
  text18: "Visualizza tutte le informazioni",
  text19: "Documento firmato",
  text20: "Tutti",
  text21: "Si è verificato un errore nel processo di conferma della consegna",
  text22: "Informazioni sul check-in",
  text23: "Dati raccolti durante il check-in dell'ospite",
  text24: "Nome",
  text25: "Cognome",
  text26: "Telefono",
  text27: "Data del soggiorno",
  text28: "Tipo di documento",
  text29: "Passaporto",
  text30: "Documento d'identità nazionale",
  text31: "Numero del documento",
  text32: "Scadenza del documento",
  text33: "Nazionalità",
  text34: "Data di nascita",
  text35: "Sesso",
  text36: "Femmina",
  text37: "Maschio",
  text38: "Scrivi qui il tuo ...",
  text39:
    "Ciao [guest_name],\nBenvenuto in HOTEL BARCELO MALAGA!\n\nGrazie mille per aver scelto di soggiornare da noi, ti informiamo che l'orario di check-out è entro le 10.00.\n\nInoltre, ti comunichiamo i dati di accesso alla nostra rete Wifi:\n\nRete: HOTEL-BARCELO\nPassword: xkamakj1a0\n\n\nSperiamo che il tuo soggiorno sia il più piacevole possibile.\n\nSiamo a tua disposizione alla reception 24 ore su 24.\n\nCordiali saluti!",
  text40: "Il nome del tuo alloggio è obbligatorio.",
  text41: "Le politiche dell'alloggio sono obbligatorie.",
  text42: "È necessario includere un messaggio di benvenuto.",
  text43: "Modifiche salvate correttamente",
  text44: "Errore nella richiesta",
  text45: "Registrazione avvenuta con successo.",
  text46: "😃 Ciao!! ",
  text47:
    " Hai completato con successo la procedura di creazione del tuo primo alloggio; ora puoi condividere il tuo QR affinché gli utenti possano effettuare il ",
  text48: "check-in",
  text49: "automatico 👍",
  text50: "Puoi modificare i campi inseriti in precedenza dal menu",
  text51: "Impostazioni del modello.",
  text52: "Scarica",
  text53: "Continua",
  text54: "Informazioni sul check-in.",
  text55: "Dati del check-in",
  text56: "Data della richiesta:",
  text57: " alle",
  text58: "Dati raccolti durante il check-in dell'ospite",
  text59: "Nome",
  text60: "Cognome",
  text61: "Telefono",
  text62: "Data del soggiorno",
  text63: "Tipo di documento",
  text64: "Passaporto",
  text65: "Documento d'identità nazionale",
  text66: "Numero del documento",
  text67: "Informazioni aggiuntive",
  text68: "Scadenza del documento",
  text69: "Nazionalità",
  text70: "Data di nascita",
  text71: "Sesso",
  text72: "Femmina",
  text73: "Maschio",
  text74: "Chiudi",
  text75: "Nuovo check-in",
  text76:
    "Puoi inviare il link o creare un check-in manuale tramite le seguenti opzioni.",
  text77: "Check-in",
  text78: "Check-in manuale dal pannello di amministrazione.",
  text79: "Invia check-in",
  text80: "Link di prenotazione a un ospite.",
  text81: "Caricamento, attendere...",
  text82: "Anni",
  text83: "Giorni",

  // Modal exportar
  text84: `ESPORTA`,
  text85: `Esporta i report in WACheckin`,
  text86: `Scarica il report dei check-in`,
  text87: `Scarica i check-in effettuati dai tuoi ospiti e ottieni un
    report dettagliato con informazioni come la data del check-in, tra
    gli altri dati.`,
  text88: `Scarica il report di migrazione`,
  text89: `Se la sincronizzazione automatica con l'ente migratorio non riesce,
    puoi scaricare questo report e inserire manualmente i dati del tuo
    ospite.`,

  text90: `Chiavi consegnate`,
  text91: `Autorità`,
  text92: `Scarica il rapporto di polizia`,
  text93: `Elimina check-in`,
  text94: `Non ci sono ancora ospiti registrati nel tuo alloggio`,
  text95: `Gli ospiti registrati appariranno qui`,
  text96: `ESPORTA`,
  text97: `ESPORTA`,
  text98: `ESPORTA`,

  // Corrections

  p1: `Invia`,
  p2: `Link per il check-in`,
  p3: `Scansiona`,
  p4: `L'ospite firmerà su questo dispositivo`,
  p5: `Scansionato`,
  p6: `Manuale`,
  p7: `Operatore manuale`,
  p8: `check-in`,
  p9: `Usa l'opzione di check-in manuale per registrare i tuoi ospiti direttamente dalla reception`,
  p10: `Check-in manuale`,
  p11: `Invia il link per il check-in online ai tuoi ospiti tramite WhatsApp o email per agevolare la loro registrazione prima dell'arrivo`,
  p12: `Invia check-in online`,
  p13: `Non specificato`,
  p14: `Elimina check-in`,
  p15: `Sei sicuro di voler eliminare il check-in? Non potrai recuperare i dati eliminati`,
  p16: `Elimina`,
  p17: `Annulla`,
  p18: `Sblocca tutto il potenziale con le nostre funzionalità premium`,
  p19: `Check-in automatico tramite WhatsApp`,
  p20: `Invio dei documenti dei viaggiatori`,
  p21: `Verifica dell'identità`,
  p22: `Valutazione automatica`,
  p23: `Cross-selling`,
  p24: `Gestione delle chiavi degli ospiti`,
  p25: `Fatturazione agli ospiti`,
  p26: `Non perderti i vantaggi!`,
  p27: `Passa a Premium`,

  p28: `Causale`,
  p29: `Addebito aggiuntivo`,
  p30: `Stato`,
  p31: `Pagato`,
  p32: `In sospeso`,
  p33: `Rimborsato`,
  p34: `Rimborsa addebito`,
  p35: `Rimborsa`,
  p36: `Sei sicuro di voler rimborsare l'addebito all'ospite?`,
  p37: `Documento d'identità`,
  p38: `Passaporto`,
  p39:`FILTRA`,
  p40:`Check-in completati`,
  p41:`Check-in in corso`,
  p42: `Non hai check-in in corso`,
  p43: `Informazioni sul check-in`,
  p44: `Check-in associati`,
  p45: `Nessun check-in associato.`,
  p46: `Maggiori informazioni:`,
  p47: `Data di check-in:`,
  p48: `Data di check-out:`,

  p49:`Ospite`,
  p50:`Ospiti`,


};
